// extracted by mini-css-extract-plugin
module.exports = {"primaryBadge":"PrimaryBadge_primaryBadge__S5zuV","highlightedBadge":"PrimaryBadge_highlightedBadge__I0SwW"};